import SearchResult from '@/core/search/SearchResult';

export default class ReservationSearchResult extends SearchResult {
}
